import { useQuery } from '@tanstack/react-query';

import { getCurrentUser } from '@/services/auth';

import type { IUser } from '@/types/user';

/**
 * Hook to fetch current user information from the /me endpoint.
 *
 * The token is automatically sent via Authorization header by apiClient interceptor.
 * The backend Lambda Authorizer validates the token before the /me endpoint is called.
 *
 * @param token - Token from localStorage (used only to track changes, not passed to API)
 */
export function useCurrentUser(token: string | null) {
  return useQuery<IUser, Error>({
    queryKey: ['currentUser'],
    queryFn: getCurrentUser,
    enabled: !!token,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
